import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  KeyboardDatePicker
} from '@material-ui/pickers';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel,
  ListItemText,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import Add from '@material-ui/icons/AddCircleOutline';

import Pager from 'src/utils/Pager';
import agm from '../../services/agm';
import { FaFileImport } from 'react-icons/fa';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.cyan[400],
    '&$checked': {
      color: colors.cyan[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultOccurenceTypes = {
  corretiva: true,
  preventiva: true,
  avcb: true,
  pendencia: true
}

const defaultDependencies = {
  loaded: false,
  categories: [],
  types: [],
  technicians: [],
  contracts: [],
  rotas: [],
  statusOcurrence: [],
  statusClient: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [occurenceTypes, setOccurenceTypes] = useState(defaultOccurenceTypes);
  const [category, setCategory] = useState([]);
  const [typeTechnician, setTypeTechnician] = useState(-1);
  const [technician, setTechnician] = useState(-1);
  const [contract, setContract] = useState(-1);
  const [controller, setController] = useState(-1);
  const [statusClient, setStatusClient] = useState(-1);
  const [statusOcurrence, setStatusOcurrence] = useState(-1);
  const [rote, setRote] = useState(-1);

  const [dependencies, setDependencies] = useState(defaultDependencies);

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(value,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    setPage(0);
    changeFilter(startDateTime,
      value,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeController = (event) => {
    setController(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      event.target.value,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeRote = (event) => {
    setRote(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      event.target.value);
  }

  const changeContract = (event) => {
    setContract(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      event.target.value,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeTechnician = (event) => {
    setTechnician(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      event.target.value,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeStatusOcurrence = (event) => {
    setStatusOcurrence(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      event.target.value,
      rote);
  }

  const changeStatusClient = (event) => {
    setStatusClient(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      event.target.value,
      statusOcurrence,
      rote);
  }


  const changeCategory = (event) => {
    setCategory(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      event.target.value,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeTypeTechnician = (event) => {
    setTypeTechnician(event.target.value);
    setPage(0);
    loadDependencies(event.target.value);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      -1,
      event.target.value,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      event.target.value,
      keyword,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      event.target.value,
      0,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      newPage,
      rows,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rowsPerPage,
      occurenceTypes,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  };

  const handleChange = (event) => {
    const value = { ...occurenceTypes, [event.target.name]: event.target.checked };
    setOccurenceTypes(value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      value,
      category,
      technician,
      typeTechnician,
      controller,
      contract,
      statusClient,
      statusOcurrence,
      rote);
  };

  const loadDependencies = ((value) => {
    agm.get('/ocorrencias/filtro/' + value, {}, {}).then((response) => {
      setTechnician(-1);
      if (!response.data.error) {
        setDependencies({
          categories: response.data.categorias,
          types: response.data.tipos,
          technicians: response.data.tecnicos,
          contracts: response.data.contratos,
          rotas: response.data.rotas,
          statusOcurrence: response.data.statusOcorrencia,
          statusClient: response.data.statusEmpresa
        });
      } else {
        return defaultDependencies;
      }
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    if (!dependencies.loaded) {
      loadDependencies(typeTechnician);
    }
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Ocorrências</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justify="flex-start" spacing={2}>
                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >

                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <TextField
                                fullWidth
                                disabled={!query.refine}
                                onChange={changeKeyword}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SvgIcon
                                        fontSize="small"
                                        color="action"
                                      >
                                        <SearchIcon />
                                      </SvgIcon>
                                    </InputAdornment>
                                  )
                                }}
                                placeholder={"Refinar pesquisa por, " + query.label}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>
                              <KeyboardDatePicker
                                disabled={!query.history}
                                margin="none"
                                cancelLabel="Cancelar"
                                id="startDateTime"
                                name="startDateTime"
                                label="Data Abertura Inicial"
                                format="DD/MM/YYYY"
                                value={startDateTime}
                                inputVariant="outlined"
                                onChange={changeStartDatetime}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>
                              <KeyboardDatePicker
                                disabled={!query.history}
                                margin="none"
                                cancelLabel="Cancelar"
                                id="endDateTime"
                                name="endDateTime"
                                label="Data Abertura Final"
                                inputVariant="outlined"
                                format="DD/MM/YYYY"
                                value={endDateTime}
                                onChange={changeEndDatetime}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid
                              item
                              md={2}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Categorias</InputLabel>
                                <Select notched
                                  id="category"
                                  multiple
                                  value={category}
                                  onChange={changeCategory}
                                  required
                                  fullWidth
                                  label="Categorias"
                                  name="category"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'category',
                                    id: 'category',
                                  }}
                                >

                                  {dependencies.categories.map((item) => (
                                    <MenuItem key={item.nome} value={item.id} label={item.nome} >
                                      <ColorCheckbox checked={category.indexOf(item.id) > -1} />
                                      <ListItemText primary={item.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="proccess">Status Cliente</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Status Cliente"
                                  variant="outlined"
                                  id="proccess"
                                  name="proccess"
                                  value={statusClient}
                                  onChange={changeStatusClient}
                                  inputProps={{
                                    name: 'proccess',
                                    id: 'proccess',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                  {dependencies.statusClient.map((status) => (
                                    <MenuItem key={status.id} value={status.id}>{status.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="proccess">Fase ATM</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Fase ATM"
                                  variant="outlined"
                                  id="proccess"
                                  name="proccess"
                                  value={statusOcurrence}
                                  onChange={changeStatusOcurrence}
                                  inputProps={{
                                    name: 'proccess',
                                    id: 'proccess',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todas</MenuItem>
                                  {dependencies.statusOcurrence.map((status) => (
                                    <MenuItem key={status.id} value={status.id}>{status.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="contract">Contratos</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Contratos"
                                  variant="outlined"
                                  id="contract"
                                  name="contract"
                                  value={contract}
                                  onChange={changeContract}
                                  inputProps={{
                                    name: 'contract',
                                    id: 'contract',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                  {dependencies.contracts.map((contract) => (
                                    <MenuItem key={contract.id} value={contract.id}>{contract.empresa.nome} - {contract.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>


                            <Grid
                              item
                              md={3}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="typeTechnician">Departamentos</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Departamentos"
                                  variant="outlined"
                                  id="typeTechnician"
                                  name="typeTechnician"
                                  value={typeTechnician}
                                  onChange={changeTypeTechnician}
                                  inputProps={{
                                    name: 'typeTechnician',
                                    id: 'typeTechnician',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todas</MenuItem>
                                  {dependencies.types.map((typetec) => (
                                    <MenuItem key={typetec.id} value={typetec.id}>{typetec.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="technician">Técnicos</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Tecnicos"
                                  variant="outlined"
                                  id="technician"
                                  name="technician"
                                  value={technician}
                                  onChange={changeTechnician}
                                  inputProps={{
                                    name: 'technician',
                                    id: 'technician',
                                  }}
                                >

                                  <MenuItem key={-1} value={-1}>Qualquer um</MenuItem>
                                  {dependencies.technicians.map((technician) => (
                                    <MenuItem key={technician.id} value={technician.id}>{technician.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="rote">Rotas</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Rotas"
                                  variant="outlined"
                                  id="rote"
                                  name="rote"
                                  value={rote}
                                  onChange={changeRote}
                                  inputProps={{
                                    name: 'rote',
                                    id: 'rote',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todas</MenuItem>
                                  {dependencies.rotas.map((rota) => (
                                    <MenuItem key={rota.id} value={rota.id}>{rota.nome}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormGroup row>
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.corretiva}
                                    onChange={handleChange} name="corretiva" />}
                                  label="Corretiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.preventiva}
                                    onChange={handleChange} name="preventiva" />}
                                  label="Preventiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.avcb}
                                    onChange={handleChange} name="avcb" />}
                                  label="AVCB"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.pendencia}
                                    onChange={handleChange} name="pendencia" />}
                                  label="Pendência"
                                />
                              </FormGroup>

                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={9}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={9}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={3}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justifyContent="baseline"
                  alignItems="flex-start"
                  spacing={2}
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                          size="small"
                          variant="contained"
                          startIcon={<Add />}
                          onClick={() => { openCreation(item) }}>
                          Criar Ocorrência
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                          size="small"
                          variant="contained"
                          startIcon={<FaFileImport />}
                          href={'/mgt/imports'}>
                          Importar
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>
                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
